var _path, _circle, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDateTime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1117 1.17188H12.6562V0.46875C12.6562 0.209883 12.4296 0 12.15 0C11.8704 0 11.6437 0.209883 11.6437 0.46875V1.17188H4.55625V0.46875C4.55625 0.209883 4.32961 0 4.05 0C3.77039 0 3.54375 0.209883 3.54375 0.46875V1.17188H2.08828C0.936784 1.17188 0 2.03927 0 3.10547V13.0664C0 14.1326 0.936784 15 2.08828 15H14.1117C15.2632 15 16.2 14.1326 16.2 13.0664V3.10547C16.2 2.03927 15.2632 1.17188 14.1117 1.17188ZM15.1875 13.0664C15.1875 13.6165 14.7059 14.0625 14.1117 14.0625H2.08828C1.49413 14.0625 1.0125 13.6165 1.0125 13.0664V5.30273C1.0125 5.22185 1.08334 5.15625 1.1707 5.15625H15.0293C15.1167 5.15625 15.1875 5.22185 15.1875 5.30273V13.0664Z",
    fill: "#002E6E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 13,
    r: 5,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 8C11.243 8 9 10.243 9 13C9 15.7571 11.243 18 14 18C16.7571 18 19 15.757 19 13C19 10.243 16.7571 8 14 8ZM14 16.9071C11.8456 16.9071 10.0929 15.1544 10.0929 13C10.0929 10.8457 11.8456 9.0929 14 9.0929C16.1544 9.0929 17.9071 10.8457 17.9071 13C17.9071 15.1544 16.1544 16.9071 14 16.9071Z",
    fill: "#002E6E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4331 13.006V10.9104C14.4331 10.6764 14.2434 10.4868 14.0095 10.4868C13.7756 10.4868 13.5859 10.6764 13.5859 10.9104V13.1413C13.5859 13.148 13.5876 13.1542 13.5879 13.1609C13.5823 13.2761 13.622 13.393 13.71 13.481L15.2876 15.0585C15.4531 15.224 15.7213 15.224 15.8866 15.0585C16.052 14.893 16.0521 14.6248 15.8866 14.4595L14.4331 13.006Z",
    fill: "#002E6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDateTime);
export default __webpack_public_path__ + "static/media/IconDateTime.342aae8b62eb419002d331cae5a65515.svg";
export { ForwardRef as ReactComponent };